/*
* COPYRIGHT. HSBC HOLDINGS PLC 2017. ALL RIGHTS RESERVED.

* This software is only to be used for the purpose for which it has been
* provided. No part of it is to be reproduced, disassembled, transmitted,
* stored in a retrieval system nor translated in any human or computer
* language in any way or for any other purposes whatsoever without the
* prior written consent of HSBC Holdings plc.
*/

/*
// Author: Grin Zhou
*/

import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap';
import SubGroupTitle from '../SubGroupTitle/index.js';
import DividingLine from "../DividingLine/index";

const CombinedGroup = (props) => {
  const {
    itemArray,
    onAddAction,
    onDelAction,
    addBtnText,
    removeBtnText,
    questionRel,
    titleContent,
    repeatMax
  } = props;

  const removeBtnClz = itemArray.length > 1 ? '' : 'disabled';
  const addBtnStatus = (repeatMax && repeatMax > itemArray.length) ? '' : 'none';
  const addAction = (event) => {
    /*
    * callback the onClick action for the "Add" button.
    */
    event.preventDefault();
    event.stopPropagation && event.stopPropagation();
    event.stopImmediatePropagation && event.stopImmediatePropagation();

    onAddAction && onAddAction(questionRel);

    return false;
  };
  const deleteAction = (index) => (event) => {
    /*
    * callback the onClick action for the "Delete" button.
    */
    event.preventDefault();
    event.stopPropagation && event.stopPropagation();
    event.stopImmediatePropagation && event.stopImmediatePropagation();

    onDelAction && onDelAction(questionRel, index);

    return false;
  };

  return (
    <div className="dynamic-group combined-group-item clearfix">
      {titleContent && titleContent.title &&
      <div className="form-item clearfix">
          <SubGroupTitle content={titleContent}/>
      </div>
      }

      { itemArray && itemArray.map((item, index) => {
        return (
          <div className="dynamic-item clearfix" key={`RP_group_${index}`} data-key={`group_${index}`}>
            { props.children[index] }

              <div className="group-del-btn clearfix">
                  <a
                    href={' '}
                    aria-label={removeBtnText.text}
                    data-key={ removeBtnText.dataKey }
                    className={`delete-btn ${removeBtnClz}`}
                    onClick={ deleteAction(index) }
                    data-index={ index }
                    style={ {display: itemArray.length>1 ? '' : 'none'} }
                  >
                    { removeBtnText.text }
                  </a>
              </div>

            {(itemArray.length>1 || index>0) &&
            <DividingLine />
            }
          </div>
        )
      })
      }
        <div className="add-btn-row" style={{display: addBtnStatus}}>
            <Button onClick={ addAction } disabled={ false } data-key={ addBtnText.dataKey }>
                <i aria-hidden={true} className="icon icon-add">{}</i>
              { addBtnText.text }
            </Button>
        </div>
    </div>
  )
};


CombinedGroup.propTypes = {
  itemArray: PropTypes.array.isRequired,
  onChangeAction: PropTypes.func,
  onTextChangeAction: PropTypes.func,
  onAddAction: PropTypes.func,
  onDelAction: PropTypes.func,
  addBtnText: PropTypes.object,
  removeBtnText: PropTypes.object,
  isError: PropTypes.bool,
  disabled: PropTypes.bool,
  overlapLabel: PropTypes.object,
  questionRel: PropTypes.object,
  titleContent: PropTypes.object,
  repeatMax: PropTypes.number
};

CombinedGroup.defaultProps = {
  itemArray: [],
  disabled: false,
  removeBtnText: {}
};

export default CombinedGroup


// WEBPACK FOOTER //
// ./src/shared/AOForm/components/CombinedGroup/index.js